import { Typography } from '@mui/material'
import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import but from '../../../../images/game-fact/but.png'
import { isFeuilleDeMatchFull } from '../../utils/feuilleMatch.js'
import { EMPTY_PLAYER } from '../../utils/helpers.js'
import { GAME_FACT_SOCCER_SHOT, typeShotListSoccer } from '../constants.js'
import TextCustom from '../generic/textCustom.js'
import { useGameFact } from '../useGameFact.js'
import { getVisualTimer } from '../../sports/rules.js'

const RecapSoccerShot = ({state, setState, match, onChangeText, onChangeTitle, inHistory}) => {
    const {team, shoter, timer, period, reason} = state

    const [img] = useGameFact({type : GAME_FACT_SOCCER_SHOT})

    const {homeHolders, homeSubstitutes, awayHolders, awaySubstitutes, homeTeam, awayTeam} = match

    let allPlayers = isFeuilleDeMatchFull(match) ? [...homeHolders, ...homeSubstitutes, ...awayHolders, ...awaySubstitutes] : [...match.homeTeam.players, ...match.awayTeam.players]

    let shoterPlayer = allPlayers.find(p => p._id === shoter) ?? EMPTY_PLAYER

    let teamSelected = [homeTeam, awayTeam].find(t => t._id === team)

    const actualPeriod = period ??  match.period

    const getShotTypeLabel = useCallback(() => {
        switch(reason){
            case 'cadre':
                return 'cadré'
            case 'nocadre':
                return 'non cadré'
            case 'poteau':
                return 'sur le poteau'
            case 'transversale':
                return 'sur la barre transversale'
        }
    },[reason])

    // Gestion du text
    useEffect(() => {
        if(!state.text || state.edited){
            const monText = 'Tir '+getShotTypeLabel()+' de '+shoterPlayer.lastname

            if(!inHistory)
                onChangeText && onChangeText(monText)
        }

        if(!state.title || state.edited){
            const monTitle = 'TIR'
            
            if(!inHistory){
                onChangeTitle && onChangeTitle(monTitle)
            }
                
        }
    }, [])

    

    return (
        <div style={{color : inHistory ? 'black' : 'white'}}>
            <img src={img} width={150}/>
            <Typography>Equipe : {teamSelected.name}</Typography>
            <Typography>Tireur : {shoterPlayer.lastname + (` (`+typeShotListSoccer.find(r => r.id === reason).value+`)` )}</Typography>
            {(timer !== 0 || period !== 0) && <Typography>Minute : {getVisualTimer(actualPeriod, timer, match.discipline)}</Typography>}
           
            {state.title && <TextCustom initialText={state.title} onChangeText={onChangeTitle} label={'Titre'}/>}
            {state.text && <TextCustom initialText={state.text} onChangeText={onChangeText} label={'Texte'}/>}
        </div>
    )
}

export default RecapSoccerShot